const ErrorView = () => import("./ErrorView.vue");
const ServerErrorView = () => import("./ServerErrorView.vue");
const PageRestrictedView = () => import("./PageRestrictedView.vue");
const EcommerceDisabledView = () => import("./EcommerceDisabledView.vue");

const errorRoutes = [
  {
    path: "/error",
    name: "Error",
    component: ErrorView,
    props: false,
    meta: {}
  },
  {
    path: "/server-error",
    name: "ServerError",
    component: ServerErrorView,
    props: false,
    meta: {}
  },
  {
    path: "/page-restricted",
    name: "PageRestricted",
    component: PageRestrictedView,
    props: false,
    meta: {}
  },
  {
    path: "/ecommerce-disabled",
    name: "EcommerceDisabled",
    component: EcommerceDisabledView,
    props: false,
    meta: {}
  }
];

export default errorRoutes;
